var map = {
	"./canvas-frame-lg.svg": 271,
	"./canvas-frame-md.svg": 272,
	"./canvas.svg": 273,
	"./editor_preview-1.webp": 274,
	"./editor_preview-2.webp": 275,
	"./editor_preview-3.webp": 276,
	"./editor_preview-4.webp": 277,
	"./editor_preview-5.webp": 278,
	"./editor_preview-map.webp": 279,
	"./editor_preview-star_map.webp": 280,
	"./frame-icon_1.png": 281,
	"./frame-icon_2.png": 282,
	"./frame-icon_3.png": 283,
	"./gallery_image-1.jpg": 284,
	"./gallery_image-2.jpg": 285,
	"./gallery_image-3.jpg": 286,
	"./gallery_image-4.jpg": 287,
	"./gallery_image-5.jpg": 288,
	"./horizontal-orientatio-icon.svg": 289,
	"./rigid-material.svg": 290,
	"./star-map-hero-sample-2.png": 291,
	"./star-map-hero-sample.png": 292,
	"./vertical-orientation-icon.svg": 293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1222;